import { ButtonV2, Card } from '@utilities';
import { NumeratorLogoSparkle } from '@utilities/assets';
import type { ScreenerQuestionBank } from '@api/instant_survey/types';

import styles from './_index.module.scss';

interface LibraryViewProps {
  banks: ScreenerQuestionBank[];
  isError: boolean;
  isLoading: boolean;
  onRetry: () => void;
  onSelectBank: (bank: ScreenerQuestionBank) => void;
}

const LibraryView = ({ banks, isError, isLoading, onRetry, onSelectBank }: LibraryViewProps) => (
  <>
    <p className={styles['library-view-intro']}>
      Use Numerator screener questions to qualify respondents before they continue into your survey.
      These do not count towards your total questions.
    </p>
    {isLoading && <p className={styles['library-view-intro']}>Loading question banks...</p>}
    {isError && (
      <p className={styles['library-view-intro']}>
        Screener question banks could not be loaded.{' '}
        <ButtonV2 onClick={onRetry} size="small" type="button" variant="default">
          Try again.
        </ButtonV2>
      </p>
    )}
    <div className={styles['library-view-grid']}>
      {banks.map((bank) => (
        <button
          className={styles['library-view-card-button']}
          key={bank.id}
          onClick={() => onSelectBank(bank)}
          type="button"
        >
          <Card className={styles['library-view-card']} padding="large">
            <NumeratorLogoSparkle className={styles['library-view-card-icon']} />
            <div className={styles['library-view-card-content']}>
              <span className={styles['library-view-card-title']}>{bank.name}</span>
              <span className={styles['library-view-card-description']}>{bank.description}</span>
            </div>
          </Card>
        </button>
      ))}
    </div>
  </>
);

export default LibraryView;
